import { AppBar, Grid, Toolbar, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

import { SubmitButton } from 'Elements/Form';

import VehicleBasicInfo from './VehicleBasicInfo';
import VehicleMaintenancesTable from './VehicleMaintenancesTable';
import VehicleTireMap from './VehicleTireMap';

const Height100 = styled.div`
  height: 100%;
`;

const ScrollOverflow = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 30px;
`;

type Props = {
  title: string;
  subtitle?: string;
};

export default function VehiclePage({ title, subtitle }: Props) {
  return (
    <Grid container direction="column" component={Height100}>
      <AppBar>
        <Toolbar>
          <div>
            <Typography variant="h3">{title}</Typography>
            <Typography variant="subtitle1">{subtitle}</Typography>
          </div>
          <SubmitButton color="secondary" variant="contained">
            Tallenna
          </SubmitButton>
        </Toolbar>
      </AppBar>
      <Grid component={ScrollOverflow} item xs>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <VehicleBasicInfo />
          </Grid>
          <Grid item xs={12} lg={6}>
            <VehicleTireMap />
          </Grid>
          <Grid item xs={12}>
            <VehicleMaintenancesTable />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
